export class AnswerToMark {
    isConfirmSave=false
    value :any
    id:number


}
